import { render, staticRenderFns } from "./ParallaxBackgroundImage.vue?vue&type=template&id=107ec740&"
import script from "./ParallaxBackgroundImage.vue?vue&type=script&lang=js&"
export * from "./ParallaxBackgroundImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VParallax } from 'vuetify/lib/components/VParallax';
installComponents(component, {VImg,VParallax})
